export default "__VITE_ASSET__fc2bedc8__"